<mat-expansion-panel
    [expanded]="index == opened && !itemForm.disabled"
    [disabled]="editMode | async"
    (opened)="opened = index"
    (closed)="opened === index && (opened = -1)"
    [disabled]="itemForm.disabled"
    [ngClass]="{ 'disabled-material-itemform-expansion-panel': !itemForm.value.item_visibility }"
    [class.material-item-wrapper-collapsed]="!expansionPanel.expanded"
    #expansionPanel
>
    <mat-expansion-panel-header
        class="on-hover-mat-item"
        fxLayoutGap="10px"
        fxLayout="row"
        fxLayoutAlign="space-between center"
    >
        <div fxFlex="grow" fxLayoutGap="5px" fxLayout="row" fxLayoutAlign="start center">
            <mat-checkbox
                [disabled]="!itemForm.value.name || itemForm.disabled"
                (click)="$event.stopPropagation()"
                (change)="$event ? selection?.toggle(index) : null"
                [checked]="selection?.isSelected(index)"
                class="item-checkbox"
            >
            </mat-checkbox>
            <span
                fxLayoutGap="3px"
                fxLayout="row"
                *ngIf="!editMode.value"
                (click)="onClearEditMode.emit(true)"
                class="title-item {{ disabled }}"
            >
                <mat-icon class="tb-icon">{{ Utils.getMaterialTypeIcon(materialFileType.value) }}</mat-icon>
                <span> {{ itemForm.value.title }}</span></span
            >
            <mat-form-field *ngIf="editMode.value" class="textarea-title">
                <textarea
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="1"
                    cdkAutosizeMaxRows="15"
                    #input
                    matInput
                    (click)="$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                    type="text"
                    [formControl]="itemForm.get('title') | cast"
                >
                </textarea>
            </mat-form-field>
        </div>
        <div class="tools-wrapper" fxLayout="row" fxLayoutAlign="start center">
            <ng-container *ngIf="!editMode.value">
                <button
                    [disabled]="disabled"
                    (click)="$event.stopPropagation(); editMode.next(true); onDisableSorting.emit(true)"
                    class="tools-btn"
                    mat-icon-button
                    matTooltip="Edit title"
                    i18n-matTooltip="@@editTitle"
                >
                    <mat-icon>edit</mat-icon>
                </button>

                <button
                    [disabled]="disabled"
                    (click)="
                        $event.stopPropagation();
                        itemForm.get('item_visibility').patchValue(!itemForm.value.item_visibility)
                    "
                    class="tools-btn"
                    mat-icon-button
                    [matTooltip]="
                        itemForm.value.item_visibility
                            ? 'Make it hidden while playing'
                            : 'Make it visible while playing'
                    "
                    i18n-matTooltip
                >
                    <mat-icon>{{ itemForm.value.item_visibility ? 'visibility' : 'visibility_off' }}</mat-icon>
                </button>

                <button
                    [disabled]="disabled"
                    (click)="
                        $event.stopPropagation();
                        itemForm.get('headline_visibility').patchValue(!itemForm.value.headline_visibility)
                    "
                    class="tools-btn"
                    mat-icon-button
                    [matTooltip]="
                        itemForm.value.headline_visibility
                            ? 'Hide headline in playing mode'
                            : 'Show headline in playing mode'
                    "
                    i18n-matTooltip
                >
                    <mat-icon>{{ itemForm.value.headline_visibility ? 'format_size' : 'format_clear' }}</mat-icon>
                </button>
                <button
                    [disabled]="!media?.filename"
                    (click)="$event.stopPropagation()"
                    class="tools-btn"
                    mat-icon-button
                    [matTooltip]="media?.filename"
                >
                    <mat-icon class="material-icons-outlined">info</mat-icon>
                </button>

                <!-- <button
                    [disabled]="!itemForm.value.name || itemForm.disabled"
                    (click)="$event.stopPropagation(); duplicateItem(index)"
                    class="tools-btn-icon tools-btn"
                    mat-icon-button
                    matTooltip="Duplicate"
                    i18n-matTooltip="@@duplicate"
                >
                    <mat-icon class="material-icons-outlined">file_copy</mat-icon>
                </button> -->
                <!-- <button
                    [disabled]="itemForm.disabled"
                    (click)="$event.stopPropagation(); deleteItem(index)"
                    class="tools-btn"
                    mat-icon-button
                    matTooltip="Delete"
                    i18n-matTooltip="@@delete"
                >
                    <mat-icon class="material-icons-outlined">delete</mat-icon>
                </button> -->
                <button
                    [disabled]="itemForm.disabled"
                    mat-icon-button
                    class="tools-btn-icon"
                    (click)="$event.stopPropagation()"
                    [matMenuTriggerFor]="otherToolsMenu"
                    #otherToolsMenuTrigger="matMenuTrigger"
                    i18n-matTooltip="@@otherTools"
                    matTooltip="Other tools"
                >
                    <mat-icon class="kd-icon-24">spoke</mat-icon>
                </button>
                <ng-content *ngIf="!expansionPanel.expanded"></ng-content>
            </ng-container>
            <button
                *ngIf="editMode.value"
                (click)="$event.stopPropagation(); editMode.next(false); onDisableSorting.emit(false)"
                class="tools-btn-icon"
                mat-icon-button
                matTooltip="Confirm"
                i18n-matTooltip="@@confirm"
            >
                <mat-icon>check</mat-icon>
            </button>
        </div>
        <mat-icon *ngIf="disabled" class="add-ai-btn on-loading">smart_toy</mat-icon>
    </mat-expansion-panel-header>
    <div class="file-wrapper" fxLayout="column">
        <ng-container *ngIf="itemForm.value.name">
            <div fxFlex="0 1 100%" fxLayout="column" fxLayoutAlign="center start">
                <div class="file-parent-wrap">
                    <app-media-view
                        #mediaView
                        fxLayoutAlign="start center"
                        fxFlex="0 0 100%"
                        fxFlex.lt-md="0 0 100%"
                        [ignoreThumbnail]="true"
                        [displayName]="false"
                        [media_id]="itemForm.value.name"
                        (onMediaUpdated)="media = $event"
                        [showImgModalOnClick]="true"
                    >
                        <button
                            class="remove-file"
                            color="warn"
                            type="button"
                            fxFlex="0 1 auto"
                            mat-icon-button
                            matTooltip="Remove file"
                            i18n-matTooltip
                            (click)="removeFile()"
                        >
                            <mat-icon class="md-24">delete_outline</mat-icon>
                        </button>
                    </app-media-view>
                </div>
                <mat-checkbox
                    [formControl]="itemForm.get('can_download') | cast"
                    color="primary"
                    class="can-download-wrapper mt-1"
                >
                    <div class="can-download" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                        <mat-icon class="material-icons-outlined">download_for_offline</mat-icon>
                        <span fxLayoutAlign="start center" fxLayoutGap="5px">
                            <span i18n>Learners can download</span>
                            <!-- <span class="item-name-download">{{ itemForm.value.title ?? itemForm.value.name }}</span> -->
                        </span>
                    </div></mat-checkbox
                >
            </div>
        </ng-container>
        <ng-container *ngIf="!itemForm.value.name">
            <div class="input-wrap" fxFlex="0 1 100%" fxLayout="row wrap" fxLayoutAlign="center center">
                <div
                    [ngStyle]="dropStyle"
                    fxFlex="0 0 50%"
                    fxFlex.lt-md="0 0 100%"
                    class="media-dropzone"
                    fxLayout="row wrap"
                    fxLayoutAlign="center center"
                >
                    <input
                        #fileInput
                        class="media-upload-button"
                        type="file"
                        multiple
                        (change)="prepareFiles($event)"
                        [disabled]="onSavingFile | async"
                        accept="application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.ms-powerpoint,.ppt, .pptx,
                text/plain, application/pdf,.xlsx,.xls, image/* ,.heic,audio/*, video/*, application/vnd.apple.keynote"
                    />
                </div>

                <div class="progress-wrapper" *ngIf="progress$ | async; let progress">
                    <mat-progress-bar class="progress" mode="determinate" [value]="progress"></mat-progress-bar>
                    <span class="progress-value">{{ progress }}%</span>
                </div>
            </div>
        </ng-container>
    </div>
</mat-expansion-panel>
<mat-menu
    #otherToolsMenu="matMenu"
    [hasBackdrop]="true"
    [overlapTrigger]="false"
    backdropClass="other-tools-menu-backdrop"
>
    <button
        mat-icon-button
        class="tools-btn-icon other-tools-btn"
        (click)="$event.stopPropagation()"
        [matMenuTriggerFor]="addNewBlockMenu"
        #addNewBlockMenuTrigger="matMenuTrigger"
        i18n-matTooltip="@@otherTools"
        matTooltip="Other tools"
    >
        <mat-icon>add</mat-icon>
        <span i18n>Add new block</span>
        <mat-icon>expand_more</mat-icon>
    </button>
    <button
        *ngIf="itemForm.value.id"
        [disabled]="!itemForm.value.name"
        (click)="onCreateTestFromMaterial.emit(index); otherToolsMenuTrigger.closeMenu()"
        class="tools-btn-icon tools-btn copy"
        mat-button
    >
        <mat-icon fontSet="klickdata" fontIcon="kd-icon-test" class="create-quiz-tb"></mat-icon>
        <span i18n>Create a Quiz</span>
    </button>
    <button
        [disabled]="!itemForm.value.name || itemForm.disabled"
        (click)="duplicateItem(index); otherToolsMenuTrigger.closeMenu()"
        class="tools-btn-icon tools-btn"
        mat-button
    >
        <mat-icon class="material-icons-outlined">file_copy</mat-icon>
        <span i18n>Duplicate</span>
    </button>
    <button
        *ngIf="!!media && media.type != 'text_material' && media.type != 'link'"
        (click)="downloadMedia(media); otherToolsMenuTrigger.closeMenu()"
        class="tools-btn-icon tools-btn"
        mat-button
    >
        <mat-icon>save_alt</mat-icon>
        <span i18n>Download</span>
    </button>
    <button
        [disabled]="disabled"
        (click)="deleteItem(index); otherToolsMenuTrigger.closeMenu()"
        class="tools-btn"
        mat-button
    >
        <mat-icon class="material-icons-outlined">delete</mat-icon>
        <span i18n>Delete</span>
    </button>
</mat-menu>
<mat-menu
    #addNewBlockMenu="matMenu"
    [hasBackdrop]="true"
    [overlapTrigger]="false"
    backdropClass="add-new-block-menu-backdrop"
>
    <button
        (click)="onAddNewBlock.emit({ index: index, blockType: 'text' }); otherToolsMenuTrigger.closeMenu()"
        class="tools-btn"
        mat-button
    >
        <mat-icon>post_add</mat-icon>
        <span i18n>Text block</span>
    </button>
    <button
        (click)="onAddNewBlock.emit({ index: index, blockType: 'image' }); otherToolsMenuTrigger.closeMenu()"
        class="tools-btn"
        mat-button
    >
        <mat-icon>add_photo_alternate</mat-icon>
        <span i18n>Image block</span>
    </button>
    <!-- <button
        (click)="onAddNewBlock.emit({ index: index, blockType: 'file' }); otherToolsMenuTrigger.closeMenu()"
        class="tools-btn"
        mat-button
    >
        <mat-icon>cloud_upload</mat-icon>
        <span i18n>Upload file</span>
    </button> -->
    <button
        (click)="onAddNewBlock.emit({ index: index, blockType: 'link' }); otherToolsMenuTrigger.closeMenu()"
        class="tools-btn"
        mat-button
    >
        <mat-icon>add_link</mat-icon>
        <span i18n>Link block</span>
    </button>
</mat-menu>
